import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74bcd2cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_4 = { class: "flex card-toolbar w-full" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "p-input-icon-left w-10/12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "card-toolbar w-full" }
const _hoisted_9 = { class: "flex flex-col justify-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card-toolbar w-full" }
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = ["title"]

import { fetchVariantProductsByPropertyValue, formatCategoriesProduct } from "@/_services/product/variant/productVariant";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { IProductVariantForProperty } from "@/models/product/variant/IProductVariantForProperty";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import { fetchCategoriesForDropDown } from "@/_services/category/category";
import router from "@/router";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'ListProductVariantsOfPropertyValue',
  setup(__props) {

const isInFilteredView = ref<boolean>(false);
const productVariants = Array<IProductVariantForProperty>();
const rows = ref<number>(10);
const page = ref < number > (1);
const criteria = ref<string>("");
const currentPage = ref<number>(0);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const totalRecords = ref<number>(0);
const isLoading = ref<boolean>(true);
const tableData = ref<Array<IProductVariantForProperty>>(productVariants);
const route = useRoute();
const propertyValueUuidRouteParam = ref<string | null>(null);
const selectedOptionsCategory = ref<string[]>([]);

onMounted(async () => {
    propertyValueUuidRouteParam.value = route.params.uuid as string;
    if (propertyValueUuidRouteParam.value) {
        await populateDatatable(rows.value, page.value, criteria.value);
    }
});

watch(selectedOptionsCategory, () => {
    isInFilteredView.value = selectedOptionsCategory.value.length > 0;
    handleSelectChange();
});

async function searchCategories({ search, page, hasNextPage }) {
    const [totalCategoriesRecordsForPickListApi, categoriesForPickListApi] = await fetchCategoriesForDropDown(5, page, search);
    const hasItems = categoriesForPickListApi.length > 0;
    if (hasItems && page !== totalCategoriesRecordsForPickListApi) {
        hasNextPage();
    }
    
    return categoriesForPickListApi;
}

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    criteria: string,
    categoriesFilter?: string[]
) => {
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchVariantProductsByPropertyValue(
        itemsPerPage,
        page,
        criteria,
        true,
        propertyValueUuidRouteParam.value,
        categoriesFilter
    );
    totalRecords.value = totalRecordsDt;
    isLoading.value = loadingDt;
    tableData.value = tableDataDt;
};

const handleSelectChange = async () => {
    showSpinner();
    await populateDatatable(
        rows.value,
        page.value,
        "" != criteria.value ? criteria.value : "",
        selectedOptionsCategory.value
    );
};

const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable(e.rows, e.page + 1, criteria.value, selectedOptionsCategory.value);
};

const onSearchInputDt = () => {
    showSpinner();
    let search = criteria.value.trim();
    populateDatatable(
        rows.value,
        page.value,
        "" != search ? search : "",
        selectedOptionsCategory.value
    );
}

const redirectToLastPage = () => {
    router.back();
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToLastPage()))
    }, [
      _hoisted_1,
      _createTextVNode(" Retour ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        rowHover: true,
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        rowsPerPageOptions: rowsPerPageOptions,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} produits",
        onPage: _cache[4] || (_cache[4] = ($event: any) => (onPaginate($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "w-9/12",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                    placeholder: "Rechercher un produit",
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (onSearchInputDt()), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, "Nombre total de produits : " + _toDisplayString(totalRecords.value), 1),
                (isInFilteredView.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Vous êtes en vue filtrée"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_FormKit, {
                type: "taglist",
                name: "selected-category-filter",
                label: "Rechercher une catégorie",
                placeholder: "Example: E-billet",
                modelValue: selectedOptionsCategory.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedOptionsCategory).value = $event)),
                options: searchCategories,
                "selection-appearance": "option",
                multiple: "",
                "empty-message": "Aucune catégorie trouvée",
                "load-on-created": "false",
                loadOnScroll: "false",
                debounce: "1000"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun produit trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Produit"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "brand",
              header: "Marque"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.brand), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "category",
              header: "Catégorie"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.categories?.length > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      title: _unref(formatCategoriesProduct)(slotProps.data.categories)
                    }, _toDisplayString(slotProps.data.categories[0].value), 9, _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"])
    ])
  ], 64))
}
}

})